module.exports = __webpack_public_path__ + "c_static/img/1-4足迹.4de5d75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-4足迹.jpg
// module id = ZFKt
// module chunks = 33